import React from "react";
import moment from "moment";
import { TableItemDinamico, dineroDisabledMask } from "../../../Components/Items";

function formatearValor(campo, valor) {
  if (valor === null || valor === undefined || valor === "") return "-";
  switch (campo.tipo) {
    case "fecha":
      return moment(valor).format("DD/MM/YYYY");
    case "moneda":
      return dineroDisabledMask(valor);
    case "booleano":
      return valor ? "Sí" : "No";
    case "seleccion":
      return campo.opciones?.find((o) => o.value === valor)?.label ?? valor;
    default:
      return valor;
  }
}

const TablaPreviewReporte = React.forwardRef(
  ({ catalogoPorKey, camposSeleccionados, dataSource, totalRecords, loading, onFetchData }, ref) => {
    const columns = camposSeleccionados
      .map((key) => catalogoPorKey[key])
      .filter(Boolean)
      .map((campo) => ({
        title: campo.label,
        dataIndex: campo.key,
        key: campo.key,
        sorter: campo.ordenable,
        align: campo.tipo === "moneda" || campo.tipo === "numero" ? "right" : undefined,
        render: (valor) => formatearValor(campo, valor),
      }));

    if (columns.length === 0) {
      return (
        <div style={{ textAlign: "center", padding: "40px 0", color: "#8c8c8c" }}>
          Elige al menos un campo para ver el reporte.
        </div>
      );
    }

    return (
      <TableItemDinamico
        ref={ref}
        totalRecords={totalRecords}
        loading={loading}
        dataSource={dataSource}
        columns={columns}
        onFetchData={onFetchData}
        size="small"
        rowKey={(record, index) => `${record._id}_${index}`}
        pagination={false}
        locale={{ emptyText: "Sin resultados para esta configuración" }}
      />
    );
  }
);

export default TablaPreviewReporte;
